import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { applicationClassNameConfig } from './ApplicationClass.name';

enum ApplicationClass {
  fixedAssetAcquisition = 'FA011',
  cancelFixedAssetAcquisition = 'FA012',
  fixedAssetDisposal = 'FA021',
  cancelFixedAssetDisposal = 'FA022',
  fixedAssetSales = 'FA031',
  cancelFixedAssetSales = 'FA032',
  fixedAssetTransfer = 'FA041',
  cancelFixedAssetTransfer = 'FA042',
  fixedAssetSubCategoryChange = 'FA051',
  cancelFixedAssetSubCategoryChange = 'FA052',
  cancelFixedAssetDepreciationItemChange = 'FA062',
  fixedAssetImpairmentLossEntry = 'FA071',
  cancelFixedAssetImpairmentLossEntry = 'FA072',
  fixedAssetSegmentChange = 'FA081',
  cancelFixedAssetSegmentChange = 'FA082',
  fixedAssetInformationChange = 'FA091',
  cancelFixedAssetInformationChange = 'FA092',
  fixedAssetReductionEntry = 'FA101',
  cancelFixedAssetReductionEntry = 'FA102',
  fixedAssetUnusedPeriodSetting = 'FA111',
  cancelFixedAssetUnusedPeriodSetting = 'FA112',
  fixedAssetSpecialDepreciationSetting = 'FA121',
  cancelFixedAssetSpecialDepreciationSetting = 'FA122',
  fixedAssetAdditionalDepreciationSetting = 'FA131',
  cancelFixedAssetAdditionalDepreciationSetting = 'FA132',
  fixedAssetEstimateChange = 'FA141',
  cancelFixedAssetEstimateChange = 'FA142',
  fixedAssetImpairmentAmountReversal = 'FA151',
  cancelFixedAssetImpairmentAmountReversal = 'FA152',
  fixedAssetDivision = 'FA161',
  cancelFixedAssetDivision = 'FA162',
  fixedAssetDepreciationExpensesAdjustmentEntry = 'FA171',
  cancelFixedAssetDepreciationExpensesAdjustmentEntry = 'FA172',
  fixedAssetDeclarationItemChange = 'FA181',
  cancelFixedAssetDeclarationItemChange = 'FA182',
  fixedAssetAllocationBasisSetting = 'FA191',
  cancelFixedAssetAllocationBasisSetting = 'FA192',
  aROEntry = 'FA261',
  cancelAROEntry = 'FA262',
  fixedAROEstimateChange = 'FA271',
  cancelFixedAROEstimateChange = 'FA272',
  fixedAROItemChange = 'FA281',
  cancelFixedAROItemChange = 'FA282',
}

const applicationClassMap = new Map([
  ['FA011', ApplicationClass.fixedAssetAcquisition],
  ['FA012', ApplicationClass.cancelFixedAssetAcquisition],
  ['FA021', ApplicationClass.fixedAssetDisposal],
  ['FA022', ApplicationClass.cancelFixedAssetDisposal],
  ['FA031', ApplicationClass.fixedAssetSales],
  ['FA032', ApplicationClass.cancelFixedAssetSales],
  ['FA041', ApplicationClass.fixedAssetTransfer],
  ['FA042', ApplicationClass.cancelFixedAssetTransfer],
  ['FA051', ApplicationClass.fixedAssetSubCategoryChange],
  ['FA052', ApplicationClass.cancelFixedAssetSubCategoryChange],
  ['FA062', ApplicationClass.cancelFixedAssetDepreciationItemChange],
  ['FA071', ApplicationClass.fixedAssetImpairmentLossEntry],
  ['FA072', ApplicationClass.cancelFixedAssetImpairmentLossEntry],
  ['FA081', ApplicationClass.fixedAssetSegmentChange],
  ['FA082', ApplicationClass.cancelFixedAssetSegmentChange],
  ['FA091', ApplicationClass.fixedAssetInformationChange],
  ['FA092', ApplicationClass.cancelFixedAssetInformationChange],
  ['FA101', ApplicationClass.fixedAssetReductionEntry],
  ['FA102', ApplicationClass.cancelFixedAssetReductionEntry],
  ['FA111', ApplicationClass.fixedAssetUnusedPeriodSetting],
  ['FA112', ApplicationClass.cancelFixedAssetUnusedPeriodSetting],
  ['FA121', ApplicationClass.fixedAssetSpecialDepreciationSetting],
  ['FA122', ApplicationClass.cancelFixedAssetSpecialDepreciationSetting],
  ['FA131', ApplicationClass.fixedAssetAdditionalDepreciationSetting],
  ['FA132', ApplicationClass.cancelFixedAssetAdditionalDepreciationSetting],
  ['FA141', ApplicationClass.fixedAssetEstimateChange],
  ['FA142', ApplicationClass.cancelFixedAssetEstimateChange],
  ['FA151', ApplicationClass.fixedAssetImpairmentAmountReversal],
  ['FA152', ApplicationClass.cancelFixedAssetImpairmentAmountReversal],
  ['FA161', ApplicationClass.fixedAssetDivision],
  ['FA162', ApplicationClass.cancelFixedAssetDivision],
  ['FA171', ApplicationClass.fixedAssetDepreciationExpensesAdjustmentEntry],
  ['FA172', ApplicationClass.cancelFixedAssetDepreciationExpensesAdjustmentEntry],
  ['FA181', ApplicationClass.fixedAssetDeclarationItemChange],
  ['FA182', ApplicationClass.cancelFixedAssetDeclarationItemChange],
  ['FA191', ApplicationClass.fixedAssetAllocationBasisSetting],
  ['FA192', ApplicationClass.cancelFixedAssetAllocationBasisSetting],
  ['FA261', ApplicationClass.aROEntry],
  ['FA262', ApplicationClass.cancelAROEntry],
  ['FA271', ApplicationClass.fixedAROEstimateChange],
  ['FA272', ApplicationClass.cancelFixedAROEstimateChange],
  ['FA281', ApplicationClass.fixedAROItemChange],
  ['FA282', ApplicationClass.cancelFixedAROItemChange],
]);

const rawValueToApplicationClass = rawValueToEnumWithDefault(
  applicationClassMap,
  ApplicationClass.fixedAssetAcquisition,
);

const applicationClassToDisplay = enumToNameWithDefault(ApplicationClass, applicationClassNameConfig);

const applicationClassToDisplayWithPrefix = enumToNameWithDefault(
  ApplicationClass,
  applicationClassNameConfig,
  true,
);

export {
  ApplicationClass,
  applicationClassToDisplay,
  applicationClassToDisplayWithPrefix,
  rawValueToApplicationClass,
};
